import React, { ReactNode } from 'react';
import { Stack, Text } from '@mantine/core';

export interface PlaceholderProps {
  children?: ReactNode;
  icon?: ReactNode;
}

export default function Placeholder({ children, icon }: PlaceholderProps) {
  return (
    <Stack c={'gray'} align={'center'} gap={0} display={'inline-flex'}>
      {icon}
      <Text>{children}</Text>
    </Stack>
  );
}
